import axios from "axios";
import { toast } from "react-toastify";
import {
  GetLastProjectOfBranch,
  RateContractApi,
  RateContractInfoApi,
} from ".";

export const fetchRateContracts = ({ params }) => {
  return axios
    .get(`${RateContractInfoApi}`, { params: { ...params } })
    .then((res) => {
      return res?.data;
    })
    .catch(() => {});
};

export const createRateContract = ({ data }) => {
  return axios
    .post(`${RateContractApi}`, data)
    .then((res) => {
      return res?.data;
    })
    .catch(() => {
      toast.error("Something went wrong!");
    });
};

export const deleteRateContract = ({ rateId }) => {
  return axios
    .delete(`${RateContractApi}${rateId}/`)
    .then((res) => {
      return res?.data;
    })
    .catch(() => {
      toast.error("Something went wrong!");
    });
};

export const fetchLastProjectOfBranch = ({ params }) => {
  return axios
    .get(`${GetLastProjectOfBranch}`, { params: { ...params } })
    .then((res) => {
      return res?.data;
    })
    .catch(() => {});
};
